import { render, staticRenderFns } from "./free-rights.vue?vue&type=template&id=33291c9c&scoped=true&lang=pug&"
import script from "./free-rights.vue?vue&type=script&lang=js&"
export * from "./free-rights.vue?vue&type=script&lang=js&"
import style0 from "./free-rights.vue?vue&type=style&index=0&id=33291c9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33291c9c",
  null
  
)

export default component.exports